import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const SELLER_IS_BLOCKED = gql`
  query sellerIsBlocked {
    user {
      role
    }
    seller {
      id
      name
      twinSellerId
      category
      shop {
        isOpen
        deliveryMethods {
          type
        }
      }
      status
      mainPhoneNumber
      statusHistory {
        id
        status
        createdDate
      }
      address {
        city
        provinceCode
        location {
          coordinates
        }
      }
    }
  }
`
export const SELLER_IS_BLOCKED_KEY = 'useSeller'

export const useSellerIsBlocked = (variables = {}) => {
  return useQuery({
    queryKey: [SELLER_IS_BLOCKED_KEY, variables],
    queryFn: () => client.request(SELLER_IS_BLOCKED, variables),
  })
}
